import { hydrateWidgets } from 'DVWebNodeUtils';
import { Nav } from 'DVWebNodeNav/Nav';
hydrateWidgets(Nav);
